const leftPadNumber = (number: number, length = 2): string => {
  const str = `${number}`;
  return str.length >= length
    ? str
    : Array.from({ length: length - str.length + 1 }).join("0") + str;
};

export default leftPadNumber;
